import { Type } from "class-transformer";
import { EnaioArchiveExportParams } from "./EnaioArchiveExportParams";

export class EnaioExportOptions {
    @Type(() => EnaioArchiveExportParams)
    archives: EnaioArchiveExportParams[];
}
